import { FC } from 'react';
import { ProInputNumber } from '../antd';
import SimpleFormDisabled from './subpage/disabled';
import SimpleFormItem from './subpage/simpleFormItem';
import {
  BaseSimpleFormProps,
  SimpleFormItemEnum,
  DEFAULT_STYLE,
} from './interface';
import { InputNumberProps } from 'antd/lib/input-number';
import { FormInstance } from 'antd/lib/form';

interface FormInputNumberProps extends Omit<InputNumberProps, 'onChange'> {
  onChange?: (value: any, record?: any, form?: FormInstance<any>) => void;
}
export interface SimpleFormInputNumberProps extends BaseSimpleFormProps {
  inputNumberProps?: FormInputNumberProps;
}
const simpleFormInputNumber: FC<SimpleFormInputNumberProps> = props => {
  const { disabledRender, inputNumberProps = {}, form, ...restProps } = props;
  return (
    <SimpleFormItem {...restProps}>
      {inputNumberProps?.disabled ? (
        <SimpleFormDisabled
          name={props.name}
          form={form}
          render={disabledRender}
        />
      ) : (
        <ProInputNumber
          style={DEFAULT_STYLE}
          {...inputNumberProps}
        />
      )}
    </SimpleFormItem>
  );
};

simpleFormInputNumber.displayName = SimpleFormItemEnum.SimpleFormInputNumber;

export default simpleFormInputNumber;
